(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-page"]) return;
  try {
    
(function () {
  function formatMoney(cents) {
    return (cents / 100).toLocaleString('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 });
  }

  function cartChange(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var item = cart.items.find(function (i) { return i.key === key; });
      var articleEl = document.querySelector('[data-item-key="' + key + '"]');
      if (articleEl) {
        if (qty === 0 || !item) {
          articleEl.remove();
        } else {
          var qtyInput = articleEl.querySelector('[data-action="qty-input"]');
          if (qtyInput) qtyInput.value = item.quantity;
          var priceEl = articleEl.querySelector('.rp-ci__price');
          if (priceEl) priceEl.textContent = formatMoney(item.final_price * item.quantity);
        }
      }

      var countEl = document.querySelector('.rp-cp__count');
      if (countEl) countEl.textContent = cart.item_count + (cart.item_count === 1 ? ' artículo' : ' artículos');

      var subtotalEl = document.getElementById('rp-cp-subtotal');
      var totalEl    = document.getElementById('rp-cp-total');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      if (totalEl)    totalEl.textContent    = formatMoney(cart.total_price);

      var cdSubtotal = document.getElementById('rp-cd-subtotal');
      if (cdSubtotal) cdSubtotal.textContent = formatMoney(cart.total_price);

      document.querySelectorAll('.rp-header__cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });

      if (cart.item_count === 0) {
        var itemsEl   = document.getElementById('rp-cp-items');
        var emptyEl   = document.getElementById('rp-cp-empty');
        var summaryEl = document.getElementById('rp-cp-summary');
        if (itemsEl)   itemsEl.hidden   = true;
        if (emptyEl)   emptyEl.hidden   = false;
        if (summaryEl) summaryEl.hidden = true;
      }
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var article = btn.closest('[data-item-key]');
    if (!article) return;
    var key = article.dataset.itemKey;
    var action = btn.dataset.action;
    var qtyInput = article.querySelector('[data-action="qty-input"]');
    var currentQty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

    if (action === 'remove') { cartChange(key, 0); }
    else if (action === 'decrement') { cartChange(key, currentQty > 1 ? currentQty - 1 : 0); }
    else if (action === 'increment') { cartChange(key, currentQty + 1); }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-action="qty-input"]');
    if (!input) return;
    var article = input.closest('[data-item-key]');
    if (!article) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) return;
    cartChange(article.dataset.itemKey, qty);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sel = document.getElementById('cg-sort');
  if (!sel) return;
  sel.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    window.location.href = url.toString();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var cartBtn = document.querySelector('.rp-header__cart');
  if (cartBtn) {
    cartBtn.addEventListener('click', function () {
      if (window.RpCart) window.RpCart.open();
    });
  }

  var burger = document.querySelector('.rp-header__burger');
  var drawer = document.getElementById('rp-nav-drawer');
  var overlay = drawer && drawer.querySelector('.rp-nav-drawer__overlay');
  var closeBtn = drawer && drawer.querySelector('.rp-nav-drawer__close');

  function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (burger) burger.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
      closeDrawer();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-respiro-v2"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.getElementById('rp3-form');
  if (!form) return;

  var variantsEl = document.getElementById('rp3-variants-json');
  var imagesEl   = document.getElementById('rp3-images-json');
  var variants   = variantsEl ? JSON.parse(variantsEl.textContent) : [];
  var images     = imagesEl  ? JSON.parse(imagesEl.textContent)   : [];

  function money(cents) {
    return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(cents / 100);
  }

  function getSelectedOptions() {
    var opts = [];
    form.querySelectorAll('input[type="radio"][data-option-index]:checked').forEach(function (el) {
      opts[parseInt(el.dataset.optionIndex, 10)] = el.value;
    });
    form.querySelectorAll('select[data-option-index]').forEach(function (el) {
      opts[parseInt(el.dataset.optionIndex, 10)] = el.value;
    });
    return opts;
  }

  function findVariant(opts) {
    return variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === opts[i]; });
    });
  }

  function updateMainImage(src) {
    var mainImg = document.getElementById('rp3-main-img');
    if (!mainImg || !src || mainImg.src === src) return;
    mainImg.classList.add('is-loading');
    mainImg.src = src;
    mainImg.onload = function () { mainImg.classList.remove('is-loading'); };
  }

  function setActiveThumb(src) {
    document.querySelectorAll('.rp3__thumb').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.src === src);
    });
  }

  function updateVariant(variant) {
    var vidInput = document.getElementById('rp3-variant-id');
    if (vidInput) vidInput.value = variant.id;

    var priceNow  = document.getElementById('rp3-price-now');
    var priceWas  = document.getElementById('rp3-price-was');
    var priceSave = document.getElementById('rp3-price-save');
    if (priceNow) priceNow.textContent = money(variant.price);
    if (priceWas) {
      if (variant.compare_at_price > variant.price) {
        priceWas.textContent = money(variant.compare_at_price);
        priceWas.hidden = false;
        if (priceSave) priceSave.hidden = false;
      } else {
        priceWas.hidden = true;
        if (priceSave) priceSave.hidden = true;
      }
    }

    var stickyPrice = document.getElementById('rp3-sticky-price');
    if (stickyPrice) stickyPrice.textContent = money(variant.price);

    var atcBtn = document.getElementById('rp3-atc-btn');
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available
        ? (atcBtn.dataset.labelAvailable || 'Agregar al carrito')
        : (atcBtn.dataset.labelUnavailable || 'Agotado');
    }
    var stickyBtn = document.getElementById('rp3-sticky-btn');
    if (stickyBtn) stickyBtn.disabled = !variant.available;

    if (variant.featured_image) {
      var imgMatch = images.find(function (img) { return img.id === variant.featured_image.id; });
      if (imgMatch) { updateMainImage(imgMatch.src); setActiveThumb(imgMatch.src); }
    }

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  function updatePillStates() {
    form.querySelectorAll('.rp3__option').forEach(function (fieldset) {
      var idx = parseInt(fieldset.dataset.optionIndex, 10);
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      var select  = fieldset.querySelector('select');
      var val = checked ? checked.value : (select ? select.value : null);
      var display = document.querySelector('[data-val-idx="' + idx + '"]');
      if (display && val) display.textContent = val;
      fieldset.querySelectorAll('.rp3__pill').forEach(function (pill) {
        var input = pill.querySelector('input');
        pill.classList.toggle('is-selected', !!(input && input.checked));
      });
    });
  }

  form.addEventListener('change', function (e) {
    var target = e.target;
    if (!target.matches('input[type="radio"][data-option-index], select[data-option-index]')) return;
    updatePillStates();
    var variant = findVariant(getSelectedOptions());
    if (variant) updateVariant(variant);
  });

  form.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var qtyInput = document.getElementById('rp3-qty');
    if (!qtyInput) return;
    var val = parseInt(qtyInput.value, 10) || 1;
    if (btn.dataset.action === 'inc') qtyInput.value = val + 1;
    else if (btn.dataset.action === 'dec' && val > 1) qtyInput.value = val - 1;
  });

  document.querySelectorAll('.rp3__thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      updateMainImage(btn.dataset.src);
      setActiveThumb(btn.dataset.src);
    });
  });

  function buildItemHtml(item) {
    var img = item.image ? '<img src="' + item.image + '" alt="" width="80" height="80">' : '';
    var variant = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<p class="rp-ci__variant">' + item.variant_title + '</p>' : '';
    return '<article class="rp-ci" data-item-key="' + item.key + '">'
      + '<a class="rp-ci__img-link" href="' + item.url + '" tabindex="-1" aria-hidden="true"><div class="rp-ci__img-wrap">' + img + '</div></a>'
      + '<div class="rp-ci__body"><div class="rp-ci__meta">'
      + '<h3 class="rp-ci__title"><a class="rp-ci__title-link" href="' + item.url + '">' + item.product_title + '</a></h3>'
      + variant + '</div>'
      + '<div class="rp-ci__footer"><div class="rp-ci__stepper">'
      + '<button class="rp-ci__step" data-action="decrement" aria-label="Reducir">−</button>'
      + '<input class="rp-ci__qty" type="number" value="' + item.quantity + '" data-action="qty-input">'
      + '<button class="rp-ci__step" data-action="increment" aria-label="Aumentar">+</button></div>'
      + '<span class="rp-ci__price">' + money(item.final_price) + '</span></div></div>'
      + '<button class="rp-ci__remove" data-action="remove" aria-label="Eliminar">✕</button></article>';
  }

  function syncDrawer(cart) {
    document.querySelectorAll('.rp-header__cart-count').forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
    document.querySelectorAll('.rp-cd__count').forEach(function (el) {
      el.textContent = '(' + cart.item_count + ')';
    });
    var subtotalEl = document.getElementById('rp-cd-subtotal');
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

    var itemsEl = document.getElementById('rp-cd-items');
    var emptyEl = document.getElementById('rp-cd-empty');
    var footEl  = document.getElementById('rp-cd-foot');
    if (cart.item_count > 0) {
      if (itemsEl) { itemsEl.innerHTML = cart.items.map(buildItemHtml).join(''); itemsEl.hidden = false; }
      if (emptyEl) emptyEl.hidden = true;
      if (footEl)  footEl.hidden  = false;
    } else {
      if (itemsEl) itemsEl.hidden = true;
      if (emptyEl) emptyEl.hidden = false;
      if (footEl)  footEl.hidden  = true;
    }
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var atcBtn = document.getElementById('rp3-atc-btn');
    if (atcBtn) atcBtn.classList.add('is-loading');

    var variantId = document.getElementById('rp3-variant-id');
    var qtyEl     = document.getElementById('rp3-qty');
    var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId ? variantId.value : '', quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
    .then(function (cart) {
      syncDrawer(cart);
      if (atcBtn) {
        atcBtn.classList.remove('is-loading');
        atcBtn.classList.add('is-success');
        setTimeout(function () { atcBtn.classList.remove('is-success'); }, 1800);
      }
      if (window.RpCart) window.RpCart.open();
    })
    .catch(function () {
      if (atcBtn) atcBtn.classList.remove('is-loading');
    });
  });

  var stickyEl  = document.getElementById('rp3-sticky');
  var buyEl     = document.getElementById('rp3-buy');
  var stickyBtn = document.getElementById('rp3-sticky-btn');

  if (stickyEl && buyEl) {
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }
    var stickyObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyEl.classList.toggle('is-visible', !entry.isIntersecting);
        stickyEl.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      });
    }, { threshold: 0.1 });
    stickyObs.observe(buyEl);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-respiro"] && !Shopify.designMode) return;
  try {
    
(function () {
  const form = document.getElementById('rp-form');
  if (!form) return;

  const variantsJson = document.getElementById('rp-variants-json');
  const variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
  const variantInput = document.getElementById('rp-variant-id');
  const atcBtn = document.getElementById('rp-atc');
  const priceEl = document.getElementById('rp-price');
  const featuredImg = document.getElementById('rp-featured');
  const qtyInput = form.querySelector('.rp__qty-input');

  const selectedOptions = {};

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function getSelectedVariant() {
    return variants.find(v =>
      v.options.every((opt, i) => selectedOptions[i] === opt)
    );
  }

  function updateVariant(variant) {
    if (!variant) return;
    variantInput.value = variant.id;

    if (atcBtn) {
      if (variant.available) {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Agregar al carrito — ' + formatMoney(variant.price);
      } else {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Agotado';
      }
    }

    if (priceEl && variant.compare_at_price > variant.price) {
      const savings = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
      priceEl.innerHTML =
        '<s class="rp__price-compare">' + formatMoney(variant.compare_at_price) + '</s>' +
        '<span class="rp__price-sale">' + formatMoney(variant.price) + '</span>' +
        '<span class="rp__badge-sale">' + savings + '% OFF</span>';
    } else if (priceEl && variant.price) {
      priceEl.innerHTML = '<span class="rp__price-current">' + formatMoney(variant.price) + '</span>';
    }

    if (variant.featured_image && featuredImg) {
      featuredImg.src = variant.featured_image.src;
    }
  }

  document.querySelectorAll('.rp__opt-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const idx = parseInt(btn.dataset.optionIndex, 10);
      selectedOptions[idx] = btn.dataset.value;

      document.querySelectorAll('.rp__opt-btn[data-option-index="' + idx + '"]').forEach(b => {
        b.classList.toggle('rp__opt-btn--selected', b === btn);
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });

      updateVariant(getSelectedVariant());
    });
  });

  document.querySelectorAll('.rp__qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const delta = parseInt(btn.dataset.qtyChange, 10);
      const current = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, current + delta);
    });
  });

  const thumbs = document.querySelectorAll('.rp__thumb');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      if (featuredImg) featuredImg.src = thumb.dataset.src;
      thumbs.forEach(t => t.classList.remove('rp__thumb--active'));
      thumb.classList.add('rp__thumb--active');
    });
  });

  const firstVariant = variants[0];
  if (firstVariant) {
    firstVariant.options.forEach((opt, i) => { selectedOptions[i] = opt; });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
